import api from "!../../../../node_modules/.pnpm/style-loader@2.0.0_webpack@4.47.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/.pnpm/css-loader@2.1.1_webpack@4.47.0/node_modules/css-loader/dist/cjs.js!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/.pnpm/sass-loader@10.5.2_sass@1.99.0_webpack@4.47.0/node_modules/sass-loader/dist/cjs.js!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/index.js??vue-loader-options!./business.vue?vue&type=style&index=0&id=0882477d&prod&lang=scss&scoped=true";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};